import React from "react";
import {WithdrawPhase, WithdrawState} from "../../payments/PaymentsReducer";
import ChooseAddress from "../withdraw/ChooseAddress";
import ChooseAmount from "../withdraw/ChooseAmount";
import ConfirmWithdraw from "../withdraw/ConfirmWithdraw";
import WithdrawResponseView from "../withdraw/WithdrawResponseView";
import {t} from "../../i18n";
import {ACHConfirmWithdraw} from "../withdraw/ACHConfirmWithdraw";
import CloseIcon from "../../utils/closeIcon"
import { ReactNode } from "react-markdown";
import { PaymentMethod } from "../../http/protocol";
import MayaConfirmWithdraw from "../withdraw/MayaConfirmWithdraw";


interface Props {
    type: string
    withdraw? : WithdrawState;
    handleClickOk?: () => void;
}

type AllProps = Props;

export class GenericPaymentComponent extends React.Component<AllProps, any> {
    constructor(props:AllProps) {
        super(props);
    }

    confirmComponent(activeMethod?: PaymentMethod) {
        if (!activeMethod) {
            return <></>
        }

        if (activeMethod.achBankTransfer) {
            return <ACHConfirmWithdraw/>
        }

        if (activeMethod.provider == 'maya'  &&  activeMethod.code == 'MAYA_FUND_WALLET') {
            return <MayaConfirmWithdraw/>
        }

        return <ConfirmWithdraw/>
    }

    renderWithdraw() {
        let withdraw = this.props.withdraw != undefined ? this.props.withdraw : {};
        let phase = withdraw && withdraw.phase;

        return(
            <div className="withdraw-title">
                {phase == WithdrawPhase.CHOOSE_ADDRESS && withdraw && withdraw.activeMethod && (
                    <ChooseAddress />
                )}
                {phase == WithdrawPhase.CHOOSE_PROVIDER && (
                    <ChooseAddress />
                )}
                {phase == WithdrawPhase.CHOOSE_AMOUNT && (
                    <ChooseAmount />
                )}
                {phase == WithdrawPhase.CONFIRM_WITHDRAW && this.confirmComponent(withdraw.activeMethod)}

                {phase == WithdrawPhase.WITHDRAW_RESPONSE && this.props.withdraw && this.props.handleClickOk && (
                    <WithdrawResponseView onClick={this.props.handleClickOk}/>
                )}
                {phase === WithdrawPhase.REQUEST_DENIED && (
                    <div className="requestDenied">
                        <CloseIcon className={`invalid-icon`} animate={true} />
                        <span>{t(`withdraw.requestDenied-reason.${withdraw.withdrawResponse?.result ?? 'ERROR'}`)}</span>
                    </div>
                )}
                {phase === WithdrawPhase.ERROR && (
                    <div className="requestDenied">
                        <CloseIcon className={`invalid-icon`} animate={true} />
                        <span>{t("withdraw.withdrawError")}</span>
                    </div>
                )}
            </div>
        )
    }

    renderDeposit() {
        return(
            <div>Deposit</div>
        )
    }

    render(): ReactNode | ReactNode[]  {
        if(this.props.type == "withdraw") {
            return this.renderWithdraw()
        }
        if(this.props.type == "deposit") {
            return  this.renderDeposit()
        }
    }
}